(() => {
  if (window.noshemetBuilderEditorReady) return;
  window.noshemetBuilderEditorReady = true;
  const initialized = new WeakSet();
  function init(root) {
  if (!root || initialized.has(root)) return;
  initialized.add(root);
  const copy = JSON.parse(root.dataset.texts);
  const format = (key, values = {}) => String(copy[key] ?? '').replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match);
  // The hub is the source of truth for the tiers (the owner edits them in /admin/gifts) and it
  // builds the bundle itself: a real Shopify bundle, one cart line, stock from the components, no discount.
  const HUB = (root.dataset.hub || 'https://portal.asifcosmetics.co.il').replace(/\/$/, '');
  const PROGRAM = root.dataset.cbProgram || 'noshemet'; // which hub rules price this page
  let tiers = { 2: 20, 3: 27, 4: 35, 5: 38 }; // last resort when neither the page nor the hub knows
  let minCount = 2;
  // 15.10.2026, the owner: the same product up to N times; the hub's rules say N, the tiers count units
  let maxPerProduct = 3;
  let maxCount = 8; // units in one bundle; the hub refuses more, so the page stops there instead of failing at the button
  // first paint: the rules the hub wrote into the shop metafield (the section drew the cards from the same copy)
  try {
    const seed = JSON.parse(root.dataset.cbRules || 'null');
    if (seed && Array.isArray(seed.tiers) && seed.tiers.length) {
      tiers = Object.fromEntries(seed.tiers.map(t => [t.count, t.percent]));
      minCount = seed.min || minCount;
      maxPerProduct = seed.maxPerProduct || maxPerProduct;
      maxCount = seed.max || maxCount;
    }
  } catch (e) { /* the hub answer below corrects it */ }
  let busy = false;
  let lastTotal = 0;
  const cards = [...root.querySelectorAll('[data-builder-product]')];
  const products = new Map(cards.map(card => [card.dataset.productId, {
    id: card.dataset.productId,
    variantId: card.dataset.variantId,
    name: card.querySelector('h3').textContent,
    price: Number(card.dataset.price),
    image: card.querySelector('img').src,
    soldOut: card.querySelector('[data-builder-toggle]').disabled,
    card,
  }]));
  const selected = new Map(); // product id → units of it in the bundle
  const units = () => { let n = 0; for (const q of selected.values()) n += q; return n; };
  const money = value => new Intl.NumberFormat('he-IL', {
    style: 'currency', currency: 'ILS', minimumFractionDigits: 0, maximumFractionDigits: 2,
  }).format(value / 100);
  const tierList = () => Object.entries(tiers).map(([k, v]) => [Number(k), v]).sort((a, b) => a[0] - b[0]);
  const rateFor = count => {
    let rate = 0, best = -1;
    for (const [t, v] of tierList()) { if (count >= t && t > best) { best = t; rate = v; } }
    return rate;
  };
  const maxTier = () => Math.max(...tierList().map(([t]) => t));
  const firstRate = () => rateFor(minCount); // the percent she gets at the smallest allowed bundle
  const chosen = root.querySelector('[data-builder-chosen]');
  const totalEl = root.querySelector('[data-builder-total]');
  const totalRow = root.querySelector('[data-builder-total-row]');
  const originalEl = root.querySelector('[data-builder-original]');
  const savingEl = root.querySelector('[data-builder-saving]');
  const status = root.querySelector('[data-builder-status]');
  const countEl = root.querySelector('[data-builder-count]');
  const empty = root.querySelector('[data-builder-empty]');
  const clear = root.querySelector('[data-builder-clear]');
  const checkout = root.querySelector('[data-builder-checkout]');
  const errorEl = root.querySelector('[data-builder-error]');
  const bar = root.querySelector('[data-builder-bar]');
  const barText = root.querySelector('[data-builder-bar-text]');
  const barAdd = root.querySelector('[data-builder-bar-add]');
  const tiersWrap = root.querySelector('.nb-tiers');
  const bump = el => { if (!el) return; el.classList.remove('nb-bump'); void el.offsetWidth; el.classList.add('nb-bump'); };
  const missingText = n => n === 1 ? copy.mobile_one || 'מוצר אחד' : format('mobile_many', {count: n});
  // the tier cards follow the hub's table (how many tiers, which counts, which percents)
  function renderTiers() {
    if (!tiersWrap) return;
    const list = tierList();
    tiersWrap.replaceChildren(...list.map(([count, rate], i) => {
      const el = document.createElement('div');
      el.className = 'nb-tier'; el.dataset.builderTier = String(count);
      const label = document.createElement('span');
      label.textContent = i === list.length - 1 ? count + ' מוצרים ומעלה' : count + ' מוצרים';
      const strong = document.createElement('strong'); strong.textContent = rate + '%';
      el.append(label, strong);
      return el;
    }));
  }
  // − n +, in the site's own order (snippets/quantity-selector: minus first): one on every card, one on every summary row
  function makeStepper(product, where) {
    const wrap = document.createElement('div');
    wrap.className = 'nb-qty';
    const minus = document.createElement('button');
    minus.type = 'button'; minus.className = 'nb-qty-btn'; minus.dataset.qty = 'minus'; minus.textContent = '−';
    const value = document.createElement('span');
    value.className = 'nb-qty-value'; value.setAttribute('aria-live', 'polite');
    const plus = document.createElement('button');
    plus.type = 'button'; plus.className = 'nb-qty-btn'; plus.dataset.qty = 'plus'; plus.textContent = '+';
    minus.addEventListener('click', () => change(product.id, -1, where, 'minus'));
    plus.addEventListener('click', () => change(product.id, 1, where, 'plus'));
    wrap.append(minus, value, plus);
    return wrap;
  }
  function paintStepper(wrap, product, qty, atMax) {
    const [minus, value, plus] = wrap.children;
    value.textContent = String(qty);
    minus.setAttribute('aria-label', qty === 1 ? format('remove_label', {name: product.name}) : format('qty_minus_label', {name: product.name}));
    plus.setAttribute('aria-label', format('qty_plus_label', {name: product.name}));
    minus.disabled = busy;
    plus.disabled = busy || atMax || qty >= maxPerProduct;
  }
  // the card's own stepper and the note under it, made once; the toggle stays the way in (and the sold-out state)
  for (const product of products.values()) {
    product.stepper = makeStepper(product, 'card');
    product.stepper.hidden = true;
    product.note = document.createElement('p');
    product.note.className = 'nb-qty-note'; product.note.hidden = true;
    product.card.querySelector('[data-builder-toggle]').after(product.stepper, product.note);
  }
  // a click moves one unit; focus stays on the control she used, or on the way back in when the product left the bundle
  function change(id, delta, where, which) {
    const product = products.get(id);
    if (busy || (delta < 0 && where === 'card' && Date.now() - (product.shownAt || 0) < 450)) return;
    if (delta > 0 && units() >= maxCount) return;
    const next = (selected.get(id) || 0) + delta;
    if (!selected.has(id) && next > 0) product.shownAt = Date.now();
    if (next <= 0) selected.delete(id);
    else selected.set(id, Math.min(next, maxPerProduct));
    render();
    const qty = selected.get(id) || 0;
    if (!qty) { product.card.querySelector('[data-builder-toggle]').focus({preventScroll: where !== 'card'}); return; }
    const scope = where === 'card' ? product.stepper : chosen.querySelector('[data-product-row="' + id + '"] .nb-qty');
    if (!scope) return;
    const target = scope.querySelector('[data-qty="' + which + '"]');
    (target && !target.disabled ? target : scope.querySelector('[data-qty="minus"]')).focus({preventScroll: true});
  }
  function render() {
    const count = units();
    const atMax = count >= maxCount; // not "full": the loop below has its own const full (the struck price)
    const rate = rateFor(count);
    const top = maxTier();
    let original = 0;
    chosen.replaceChildren();
    for (const [id, qty] of selected) {
      const product = products.get(id);
      original += product.price * qty;
      const row = document.createElement('li');
      row.dataset.productRow = id;
      const img = document.createElement('img');
      img.src = product.image; img.alt = ''; img.width = 52; img.height = 52;
      const name = document.createElement('span'); name.className = 'nb-chosen-name'; name.textContent = product.name;
      const stepper = makeStepper(product, 'summary');
      paintStepper(stepper, product, qty, atMax);
      row.append(img, name, stepper); chosen.append(row);
    }
    // the hub's own sum: the full price less the tier, rounded once (customBundle.ts bundlePrice)
    const total = Math.round(original / 100 * (100 - rate)); // the same float steps as bundlePrice, so never an agora apart
    for (const product of products.values()) {
      const qty = selected.get(product.id) || 0;
      const button = product.card.querySelector('[data-builder-toggle]');
      button.setAttribute('aria-pressed', String(qty > 0));
      button.textContent = product.soldOut ? copy.sold_out : copy.add_label;
      button.disabled = product.soldOut || busy || atMax;
      button.hidden = qty > 0;
      product.stepper.hidden = qty === 0;
      if (qty) paintStepper(product.stepper, product, qty, atMax);
      product.note.hidden = qty < maxPerProduct;
      product.note.textContent = format('qty_max_note', {max: maxPerProduct});
      product.card.classList.toggle('nb-selected', qty > 0);
      const discounted = product.card.querySelector('[data-builder-card-price]');
      discounted.textContent = money(Math.round(product.price * (100 - rate) / 100));
      const full = product.card.querySelector('[data-builder-card-original]');
      full.hidden = rate === 0; full.textContent = money(product.price);
    }
    countEl.textContent = count === 0 ? copy.count_zero : count === 1 ? copy.count_one : format('count_many', {count});
    const vals = {rate, next_rate: rateFor(count + 1), first_rate: firstRate(), min: minCount, missing_text: missingText(Math.max(1, minCount - count))};
    status.textContent = atMax ? format('status_full', {max: maxCount})
      : count === 0 ? format('status_zero', vals)
      : count < minCount ? format('status_one', vals)
      : count < top ? format('status_next', vals)
      : format('status_max', vals);
    const summaryLine = count ? (count === 1 ? copy.mobile_one : format('mobile_many', {count})) + ' · ' + rate + '% · ' + money(total) : copy.mobile_empty;
    root.querySelector('[data-builder-mobile-summary]').textContent = summaryLine;
    totalEl.textContent = money(total); originalEl.textContent = money(original);
    originalEl.hidden = rate === 0; savingEl.textContent = money(original - total);
    if (total !== lastTotal && total > 0) bump(totalEl);
    lastTotal = total;
    if (totalRow) totalRow.hidden = count === 0;
    root.querySelector('[data-builder-rate]').textContent = rate + '%';
    root.querySelector('[data-builder-savings-row]').hidden = rate === 0;
    empty.hidden = count > 0; clear.hidden = count === 0;
    for (const tier of root.querySelectorAll('[data-builder-tier]')) {
      const threshold = Number(tier.dataset.builderTier);
      tier.classList.toggle('nb-tier-reached', count >= threshold);
      tier.setAttribute('aria-current', String(threshold === (Math.min(count, top))));
    }
    root.querySelector('[data-builder-progress]').style.width = Math.min(count / top, 1) * 100 + '%';
    const canAdd = !busy && count >= minCount;
    if (checkout) checkout.disabled = !canAdd;
    if (bar) {
      bar.hidden = false;
      bar.classList.toggle('is-on', selected.size > 0);
      if (barText) barText.textContent = summaryLine;
      if (barAdd) barAdd.disabled = !canAdd;
    }
  }
  // the tiers the server will honour; the cards and the sentences on the page follow them
  fetch(HUB + '/api/bundles/custom?program=' + encodeURIComponent(PROGRAM), {headers: {Accept: 'application/json'}})
    .then(r => r.ok ? r.json() : null)
    .then(cfg => {
      if (!cfg || !cfg.ok || !cfg.tiers) return;
      tiers = cfg.tiers; minCount = cfg.min || minCount;
      maxPerProduct = cfg.maxPerProduct || maxPerProduct;
      maxCount = cfg.max || maxCount;
      for (const [id, qty] of selected) if (qty > maxPerProduct) selected.set(id, maxPerProduct);
      renderTiers();
      root.querySelectorAll('[data-cb-max-rate]').forEach(el => { el.textContent = String(Math.max(...tierList().map(([, v]) => v))); });
      root.querySelectorAll('[data-cb-max-per-product]').forEach(el => { el.textContent = String(maxPerProduct); });
      render();
    })
    .catch(() => {});
  // A logged-in customer's first name for the line "שם" on her own cart line, or '' for anyone else and for any doubt.
  // Asked from Shopify at the moment of the tap through a fresh URL (never a cached page, never an old tab), and
  // refused unless Shopify rendered it right now: its render time against the response's own Date header, so a
  // wrong phone clock plays no part. On her cart line the name reaches nobody outside the site; in a product title
  // it would reach Google Analytics and Meta with every add to cart (measured 16.9.2026).
  async function shopperFirstName(rootUrl) {
    try {
      const res = await fetch(rootUrl + '?sections=cb-identity&t=' + Date.now(), {headers: {Accept: 'application/json'}, cache: 'no-store', credentials: 'same-origin'});
      if (!res.ok) return '';
      const html = ((await res.json()) || {})['cb-identity'] || '';
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cb-identity]');
      if (!el) return '';
      const served = Date.parse(res.headers.get('date') || '') / 1000;
      const rendered = Number(el.getAttribute('data-ts'));
      if (!served || !rendered || Math.abs(served - rendered) > 60) return '';
      return String(el.getAttribute('data-first-name') || '')
        .replace(/[\u0000-\u001f\u007f-\u009f\u200e\u200f\u202a-\u202e\u2066-\u2069]/g, '')
        .replace(/\s+/g, ' ').trim().slice(0, 30).trim();
    } catch (e) {
      return '';
    }
  }
  async function addBundleToCart() {
    if (busy || units() < minCount) return;
    busy = true;
    const label = checkout.textContent;
    const barLabel = barAdd ? barAdd.textContent : '';
    const busyLabel = copy.checkout_busy || 'מכינים את המארז שלך…';
    checkout.textContent = busyLabel;
    checkout.setAttribute('aria-busy', 'true');
    if (barAdd) { barAdd.textContent = busyLabel; barAdd.setAttribute('aria-busy', 'true'); }
    if (errorEl) errorEl.hidden = true;
    render();
    try {
      // a product taken twice is sent twice: the hub makes it one component of quantity 2
      const variantIds = [...selected].flatMap(([id, qty]) => Array(qty).fill(products.get(id).variantId));
      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      // her first name, from HER logged-in session at this very moment, asked alongside the bundle (owner, 16.9.2026)
      const [res, name] = await Promise.all([
        fetch(HUB + '/api/bundles/custom', {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({variantIds, program: PROGRAM}),
        }),
        shopperFirstName(rootUrl),
      ]);
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.ok) throw new Error(data.error || copy.checkout_error);
      // a hub that folded the repeats into one unit built another bundle than the one on the screen: never add it
      if (Number(data.count) !== variantIds.length) throw new Error(copy.checkout_error);
      const properties = {'מה בפנים': data.inside};
      if (name) properties['שם'] = name;
      const add = await fetch(rootUrl + 'cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items: [{id: Number(data.variantId), quantity: 1, properties}]}),
      });
      if (!add.ok) throw new Error(copy.checkout_error);
      selected.clear();
      if (typeof window.opusRefreshCart === 'function') { try { await window.opusRefreshCart(); } catch (e) { /* the drawer will re-read on open */ } }
      if (typeof window.opusOpen === 'function') window.opusOpen(); else location.href = rootUrl + 'cart';
    } catch (e) {
      if (errorEl) { errorEl.textContent = (e && e.message) || copy.checkout_error; errorEl.hidden = false; errorEl.scrollIntoView({block: 'center', behavior: 'smooth'}); }
    } finally {
      busy = false;
      checkout.textContent = label;
      checkout.removeAttribute('aria-busy');
      if (barAdd) { barAdd.textContent = barLabel; barAdd.removeAttribute('aria-busy'); }
      render();
    }
  }
  if (checkout) checkout.addEventListener('click', addBundleToCart);
  if (barAdd) barAdd.addEventListener('click', addBundleToCart);
  // the card's button puts the first unit in; the stepper that replaces it takes over from there
  cards.forEach(card => card.querySelector('[data-builder-toggle]').addEventListener('click', () => change(card.dataset.productId, 1, 'card', 'plus')));
  clear.addEventListener('click', () => { selected.clear(); render(); });
  let category = 'all', skin = 'all', family = 'all';
  const search = root.querySelector('[data-builder-search]');
  function filter() {
    let visible = 0;
    const query = search.value.trim().toLocaleLowerCase('he-IL');
    for (const card of cards) {
      const skinMatches = skin === 'all' || card.dataset.category === 'בישום' || card.dataset.skin.split(' ').includes(skin);
      const familyMatches = family === 'all' || card.dataset.category !== 'בישום'
        || (family === '__more' ? moreFamilies.has(card.dataset.family || '') : (card.dataset.family || '') === family);
      card.hidden = !(category === 'all' || card.dataset.category === category) || !skinMatches || !familyMatches || !card.dataset.search.includes(query);
      if (!card.hidden) visible++;
    }
    root.querySelector('[data-builder-no-results]').hidden = visible > 0;
    root.querySelector('[data-builder-results]').textContent = visible === 1 ? copy.results_one : format('results_many', {count: visible});
    root.querySelector('.nb-skin-filter').hidden = category === 'בישום';
    if (familyRow) familyRow.hidden = category !== 'בישום';
  }
  root.querySelectorAll('[data-builder-category]').forEach(button => button.addEventListener('click', () => {
    category = button.dataset.builderCategory;
    family = 'all'; // leaving בישום clears the family, so nothing filters invisibly
    root.querySelectorAll('[data-builder-family]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.builderFamily === 'all')));
    root.querySelectorAll('[data-builder-category]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    filter();
  }));
  root.querySelectorAll('[data-builder-skin]').forEach(button => button.addEventListener('click', () => {
    skin = button.dataset.builderSkin;
    root.querySelectorAll('[data-builder-skin]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    filter();
  }));
  // Scent families, under "בישום" only: the five biggest get a chip of their own and the rest sit behind "עוד"
  // (the owner, 16.9.2026). The names come from the cards, so a rename in Enigma renames the chip by itself.
  const familyRow = root.querySelector('[data-builder-family-row]');
  const familyChips = root.querySelector('[data-builder-family-chips]');
  const moreFamilies = new Set();
  if (familyRow && familyChips && !familyChips.children.length) {
    const counts = new Map();
    for (const card of cards) {
      if (card.dataset.category !== 'בישום') continue;
      const name = (card.dataset.family || '').trim();
      if (name) counts.set(name, (counts.get(name) || 0) + 1);
    }
    const ordered = [...counts.entries()].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0], 'he-IL'));
    const top = ordered.slice(0, 5);
    ordered.slice(5).forEach(([name]) => moreFamilies.add(name));
    if (top.length > 1) {
      const chip = (value, label, pressed) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.builderFamily = value;
        button.setAttribute('aria-pressed', String(pressed));
        button.textContent = label;
        familyChips.appendChild(button);
      };
      chip('all', copy.family_all || 'כל המשפחות', true);
      top.forEach(([name]) => chip(name, name, false));
      if (moreFamilies.size) chip('__more', copy.family_more || 'עוד', false);
      root.querySelectorAll('[data-builder-family]').forEach(button => button.addEventListener('click', () => {
        family = button.dataset.builderFamily;
        root.querySelectorAll('[data-builder-family]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        filter();
      }));
    }
  }
  search.addEventListener('input', filter);
  root.querySelector('[data-builder-reset-search]').addEventListener('click', () => {
    search.value = ''; root.querySelector('[data-builder-skin="all"]').click(); root.querySelector('[data-builder-category="all"]').click(); search.focus();
  });
  render();
  filter();
  }
  const initWithin = scope => scope.querySelectorAll('[data-ns-builder]').forEach(init);
  initWithin(document);
  document.addEventListener('shopify:section:load', event => initWithin(event.target));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('[data-ns-builder]');
    if (!root) return;
    root.querySelector('[data-builder-reset-search]').click();
    event.target.scrollIntoView({block:'center', behavior:'instant'});
  });
})();
